import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';

const client = getTsCustomerPortalClient();

/**
 * Request another invitation without returning patient details or automatically retrying.
 * @returns The mutation state and functions for requesting another invitation.
 */
export function useRequestPatientReinvitation() {
  return client.requestPatientReinvitation.useMutation({ retry: false });
}
